// removed by extract-text-webpack-plugin
module.exports = {"buttonwrapper":"buttonwrapper__L5ql7","top":"top__2g32u","button":"button__2tfzN","icon":"icon__1KPqp","plus":"plus___8rXC","minus":"minus__SYQu1"};


//////////////////
// WEBPACK FOOTER
// ./components/gemView/gemZoomControls/scss/zoomcontrols.scss
// module id = bGVC
// module chunks = 0